import React from 'react';
import { compose } from 'recompose';
import Layout from '../utils/layout';
import { graphql } from 'gatsby';
import {
  withAuthorization,
  withEmailVerification,
} from '../utils/Session';
import LinkAcconts from '../components/scenes/LinkAccounts/LinkAccounts';

const condition = authUser => !!authUser;
const LinkAccontsPage = compose(
  withEmailVerification,
  withAuthorization(condition),
)(LinkAcconts);

export default () => {
  return (
    <Layout>
      <LinkAccontsPage />
    </Layout>
  );
};

export const query = graphql`
  query LinkAccountsSeo {
    site {
      siteMetadata {
        home {
          defaultTitle: title
          titleTemplate
          defaultDescription: description
          siteUrl: url
          defaultImage: image
          twitterUsername
        }
      }
    }
  }
`;
